import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSimpleButton from '@/components/AppSimpleButton.vue';
import { utcDateTimeToLocal } from '@/utils/dateTime';
import MemberDialog from '../MemberList/script-dialog';
import { showErrors } from '@/utils/snack';
import { findMember } from './gql';

var MemberDetail = /*#__PURE__*/function (_mixins) {
  _inherits(MemberDetail, _mixins);

  var _super = _createSuper(MemberDetail);

  function MemberDetail() {
    var _this;

    _classCallCheck(this, MemberDetail);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '会员管理'
    }, {
      text: '会员管理',
      to: {
        name: 'MemberList'
      }
    }];
    _this.disableConfirm = false;
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.loading = false;
    _this.headers = [{
      text: '学校',
      value: 'school',
      sortable: false
    }, {
      text: '入学年',
      value: 'year',
      sortable: false
    }, {
      text: '班',
      value: 'className',
      sortable: false
    }, {
      text: '学生姓名',
      value: 'realname',
      sortable: false
    }, {
      text: '联系电话',
      value: 'phone',
      sortable: false
    }, {
      text: '是否默认',
      value: 'isDefault',
      sortable: false
    }];
    _this.addresses = [];
    _this.options = {
      sortBy: ['m_createdAt'],
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    return _this;
  }

  _createClass(MemberDetail, [{
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.onResize();
                this.getMemberById();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "getMemberById",
    value: function () {
      var _getMemberById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, result, member, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = this.$route.params.id;
                _context2.prev = 1;
                _context2.next = 4;
                return this.$apollo.query({
                  query: findMember,
                  variables: {
                    memberId: +id
                  }
                });

              case 4:
                result = _context2.sent;
                member = result.data.findMember;
                this.breadcrumbs.push({
                  text: "".concat(member.uniqueId)
                });
                this.targetMember = member;
                this.addresses = member.addresses;
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 11]]);
      }));

      function getMemberById() {
        return _getMemberById.apply(this, arguments);
      }

      return getMemberById;
    }()
  }, {
    key: "deleteConfirm",
    value: function () {
      var _deleteConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.deleteRequest();

              case 2:
                this.$router.push({
                  name: 'MemberList'
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteConfirm() {
        return _deleteConfirm.apply(this, arguments);
      }

      return deleteConfirm;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }
  }]);

  return MemberDetail;
}(mixins(MemberDialog));

MemberDetail = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleButton: AppSimpleButton
  }
})], MemberDetail);
export default MemberDetail;